import { useQuery } from '@tanstack/react-query';

import { get } from '../api/ventura/adGroup';
import { isAchHost } from '../util/achAuth';
import { unwrapAchShowModel } from '../util/achEnvelope';
import mapAdGroupToForm from '../util/mapAdGroupToForm';
import { useConfig } from './useConfig';

function useAdGroup(adGroupId: number) {
  // The campaign (== AdGroup) SHOW opts into the per-domain flip:
  // apiHostFor('campaigns') resolves to ACH iff campaigns is flipped ON (migrated
  // list + env gate), else the plain Rails apiHost. ACH wraps the resource in the
  // D2 {model} envelope (RD-2), so unwrap it BEFORE mapAdGroupToForm — the mapper
  // dereferences campaign_urls/pixel_urls and would throw on the envelope. The
  // unwrap is a no-op on Rails (bare object). Every AdGroup WRITE stays on the
  // Rails apiHost (saveAdGroup/copy/paste/pause_toggle in api/ventura/adGroup).
  const { apiHostFor } = useConfig();
  const campaignsHost = apiHostFor('campaigns');

  const adGroup = useQuery({
    queryKey: ['adGroup', adGroupId],
    queryFn: () => get(campaignsHost, adGroupId).then((res) => unwrapAchShowModel(res, isAchHost(campaignsHost))),
    select: mapAdGroupToForm,
  });

  return adGroup;
}

export default useAdGroup;
